import { Card } from '#record/card';
import { PatchCardProps } from '#submission/patchdetail';
import { useT } from 'apprise-frontend-core/intl/language';
import { Grid } from 'apprise-ui/grid/grid';
import { NamedProperty } from 'apprise-ui/utils/namedproperty';
import { avlType } from './constants';
import { AvlPatch } from './model';
import { TenantLabel } from 'apprise-frontend-iam/tenant/label';
import { useValidationIssueIndex } from '#submission/validator';
import { TagLabel } from 'apprise-frontend-tags/tag/label';


export const AvlPatchCard = (props: PatchCardProps<AvlPatch>) => {

    const t = useT()

    // const { current, record, previous } = props
    const { record } = props

    const avl = record[avlType]
    // const previousAvl = previous?.[avlType] ?? {}

    const issue = useValidationIssueIndex()

    return <Card minWidth={400}>
        {avl.declarations.map((decl, idx) =>
            <Grid key={idx} rowGap={8} columnGap={10} style={{ borderBottom: '1px solid lightgray', marginBottom: 10, paddingBottom: 10 }}>

                <Grid.Row>
                    <Grid.Col>
                        <NamedProperty status={issue[`${idx}_avl_year`]} name={t('avl.year')}>
                            {decl.year}
                        </NamedProperty>
                    </Grid.Col>
                    <Grid.Col>
                        <NamedProperty status={issue[`${idx}_avl_species`]} name={t('avl.species')}>
                            <TagLabel noIcon noLink tag={decl.species} />
                        </NamedProperty>
                    </Grid.Col>
                    <Grid.Col>
                        <NamedProperty status={issue[`${idx}_avl_tenant`]} name={t('avl.tenant')}>
                            <TenantLabel tenant={decl.tenant} noIcon noLink />
                        </NamedProperty>
                    </Grid.Col>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Col>
                        <NamedProperty status={issue[`${idx}_avl_charterer_name`]} name={t('avl.charterer_name')}>
                            {decl.charterer.name}
                        </NamedProperty>
                    </Grid.Col>
                    <Grid.Col>
                        <NamedProperty status={issue[`${idx}_avl_charterer_address`]} name={t('avl.charterer_address')}>
                            {decl.charterer.address}
                        </NamedProperty>
                    </Grid.Col>
                </Grid.Row>

            </Grid >
        )}
    </Card>
}
